import { apiFetch } from "@core/http";
import type { components } from "@core/types/openapi";

export type ValidatorSession = components["schemas"]["ValidatorSession"];

// SPEC-301: las tres llamadas de la superficie de acceso, contra el contrato
// publicado en `api/contracts/parts/50-validator.yaml`. No redeclara reglas
// de negocio (bloqueo, no-revelación, vigencia): eso lo decide el backend.
//
// `sign-in`, `recover` y `password` ya están montadas
// (`api/src/infrastructure/http/routes/staff-access.routes.ts`,
// `createValidatorAccessRouter`) — `recover`/`password` faltaban hasta que se
// corrigió el 404 reportado por el usuario (el router solo montaba
// `sign-in`). `signOut`, más abajo, sigue sin ruta montada — ver su propio
// comentario.

export function signIn(
  username: string,
  password: string,
  keepSession: boolean,
): Promise<ValidatorSession> {
  return apiFetch<ValidatorSession>("/v1/validator/access/sign-in", {
    method: "POST",
    body: { username, password, keepSession },
  });
}

export interface RecoverPasswordResult {
  validityHours: number;
  maskedEmail?: string;
}

export function recoverPassword(email: string): Promise<RecoverPasswordResult> {
  return apiFetch<RecoverPasswordResult>("/v1/validator/access/recover", {
    method: "POST",
    body: { email },
  });
}

export function setPasswordWithToken(
  token: string,
  password: string,
  confirmation: string,
): Promise<void> {
  return apiFetch<void>("/v1/validator/access/password", {
    method: "PUT",
    body: { token, password, confirmation },
  });
}

// SPEC-302 §2 / RF-VAL-11, ANNEX-011 §2.3: la salida está montada
// (`api/src/composition/server.ts`) a diferencia de `recover`/`password`.
export function signOut(bearerToken: string): Promise<void> {
  return apiFetch<void>("/v1/validator/access/sign-out", {
    method: "POST",
    bearerToken,
  });
}
